/* Holly Wood: quiet motion (17 Oct 2026).
   1. Content below the first screen rises and fades in once as it scrolls into view.
   2. The header gains a soft shadow after scrolling.
   Nothing on the first screen is ever hidden, and everything is skipped when the visitor has "reduce motion" switched on. */
(function () {
  var header = document.querySelector('.hw-header');
  if (header) {
    // the scroll position is only read when the page actually scrolls (a read at start-up forced an early layout: PageSpeed "forced reflow")
    var onScroll = function () { header.classList.toggle('is-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 12); };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.hw-heading,.hw-craft__statement,.hw-craft__marks,.hw-project,.hw-split__img,.hw-split__title,.hw-split__body,.hw-card,.hw-step,.hw-offset__imgwrap,.hw-offset__copy,.hw-cta__text,.hw-storysplit__img,.hw-storysplit__paras,.hw-value,.hw-wide-img,.hw-pkg,.hw-istep,.hw-quote,.hw-pm';
  var setup = function () {
    var vh = window.innerHeight || 800;
    var nodes = document.querySelectorAll('main ' + SEL.split(',').join(', main '));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el); el.classList.add('is-in');
        var done = function () { el.removeAttribute('data-hw-reveal'); el.classList.remove('is-in'); el.style.removeProperty('--hw-rv-d'); el.removeEventListener('animationend', done); };
        el.addEventListener('animationend', done);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    // read every position first, then write, so the browser lays the page out once instead of once per element
    var todo = [], i, el, r;
    for (i = 0; i < nodes.length; i++) {
      el = nodes[i]; r = el.getBoundingClientRect();
      if (r.top > vh * 1.05) todo.push([el, Array.prototype.indexOf.call(el.parentNode.children, el)]);   // first screen stays untouched
    }
    for (i = 0; i < todo.length; i++) {
      todo[i][0].style.setProperty('--hw-rv-d', Math.min(todo[i][1], 4) * 70 + 'ms');
      todo[i][0].setAttribute('data-hw-reveal', ''); io.observe(todo[i][0]);
    }
    if (todo.length) document.documentElement.classList.add('hw-motion');
  };
  // start only when the visitor first scrolls, touches or presses a key: a visitor who never moves needs none of it, and the first paint and
  // the load are never slowed by it (it measured as a long task and a forced reflow in PageSpeed, 23 Oct 2026)
  var started = false, evs = ['scroll', 'touchstart', 'pointerdown', 'keydown', 'wheel'];
  var start = function () {
    if (started) return; started = true;
    for (var k = 0; k < evs.length; k++) window.removeEventListener(evs[k], start, true);
    (window.requestAnimationFrame || setTimeout)(setup);
  };
  for (var k = 0; k < evs.length; k++) window.addEventListener(evs[k], start, { capture: true, passive: true });
})();
